module.exports = __webpack_public_path__ + "static/media/banner3768.d9f468b5.jpg";